


document.addEventListener("DOMContentLoaded", function() {
        
     function removeFromCart(...variantIds) {
        if (variantIds.length === 0) {
          console.warn('No variant IDs provided for removal. Nothing to do.');
          return Promise.resolve(true); 
        }
      
        const updates = {};
        variantIds.forEach(id => {
          if (typeof id === 'number' && id > 0) { 
            updates[id] = 0; 
          } else {
            console.warn(`Invalid variant ID provided: ${id}. Skipping.`);
          }
        });
      
        if (Object.keys(updates).length === 0) {
          console.warn('No valid variant IDs to remove after filtering. Nothing to do.');
          return Promise.resolve(true); 
        }
      
        // KS 13 Sep 2026: the section id was hard-coded from an older theme, so the drawer never
        // refreshed after a removal. Resolve it from the DOM, fall back to the old constant.
        var drawerEl = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
        var sectionId = drawerEl ? drawerEl.id.replace('shopify-section-', '') : 'sections--25562165805401__cart-drawer';

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sectionId
          })
        })
        .then(response => {
          if (!response.ok) {
            return response.json().catch(() => ({ message: response.statusText })) // Fallback if JSON parsing fails
              .then(errorData => {
                throw new Error(`Failed to remove items: ${errorData.message || 'Unknown error'}`);
              });
          }
          // If response is OK, proceed to the next .then()
          return response.json(); // Or just return response if you don't need the parsed JSON
        })
        .then(data => {

          
          var countEl = document.querySelector("cart-count");
          if (countEl) countEl.innerText = data.item_count;
          const txt = data.sections ? data.sections[sectionId] : null;
          var targetElement = document.getElementById('cart-drawer');
          if (txt && targetElement) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(txt,'text/html');
            const fresh = doc.getElementById('cart-drawer');
            if (fresh) targetElement.innerHTML = fresh.innerHTML;
          }
          return true; // Indicate success
        })
        .catch(error => {
          console.error('Error removing items:', error);
          return false; // Indicate failure
        });
      }
    
    document.addEventListener("cart:change", function(event) {

              const product1ID = Number(document.querySelector('#product1')?.getAttribute('data-id'));
              const product2ID = Number(document.querySelector('#product2')?.getAttribute('data-id'));
              const freeGift1 = Number(document.querySelector('#free-gift1')?.getAttribute('data-free-gift1'));
              const freeGift2 = Number(document.querySelector('#free-gift2')?.getAttribute('data-free-gift2'));
              let product1InCart = false;
              let product2InCart = false;
              const inCart = { product1VarId: null, product2VarId: null };
        
              
              let cart = event.detail["cart"];
              let total_price = cart.total_price;
        
              cart.items.forEach((item)=>{
                if( item.product_id === product1ID){
                  product1InCart = true;
                  inCart.product1VarId = item.variant_id;
                }
                if( item.product_id === product2ID){
                  product2InCart = true;
                  inCart.product2VarId = item.variant_id;
                }
              });
      

      
              if( total_price < freeGift1 && product1InCart && product2InCart && inCart.product1VarId && inCart.product2VarId ){
                 
                   removeFromCart(inCart.product1VarId, inCart.product2VarId) // Assuming inCart is defined elsewhere
                      .then(success => {
                        if (success) {
                              console.log('remove first free gift success');
                              console.log('remvove second free gift success');
                              product1InCart = false;
                              product2InCart = false;
                        } else {
                              console.log('remove first free gift failed');
                              console.log('remvove second free gift failed');
                        }
                      })
                      .catch(error => {
                        // This catch block will only be hit if there's an unhandled error
                        // within the .then() chain itself, not from the fetch operation
                        console.error('An unexpected error occurred during removal process:', error);
                      });
                  
                  
              }
              else if( total_price < freeGift1 && product1InCart && inCart.product1VarId){
              //   alert('remove first item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product1VarId) // Assuming inCart is defined elsewhere
                  .then(success => {
                    if (success) {
                      console.log('remove first free gift success');
                       product1InCart = false;
                    } else {
                      console.log('remove first free gift failed');
                    }
                  })
                  .catch(error => {
                    console.error('An unexpected error occurred during removal process:', error);
                  });
                
               
              }
              else if( total_price < freeGift1 && product2InCart && inCart.product2VarId){
              //     alert('remove second item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product2VarId) // Assuming inCart is defined elsewhere
                    .then(success => {
                      if (success) {
                              console.log('remvove second free gift success');
                          product2InCart = false;
                      } else {
                       console.log('remvove second free gift failed');
                      }
                    })
                    .catch(error => {
                      console.error('An unexpected error occurred during removal process:', error);
                    });
               
                
              }
              else if( total_price < freeGift2 && total_price > freeGift1 && product2InCart && inCart.product2VarId){
              //   alert('remove second item condition');
              //   alert('product1incart ' +product1InCart );
              // alert('product2incart ' +product2InCart );
              //  alert('product1varId ' +inCart.product1VarId )
              //  alert('product2varId ' +inCart.product2VarId );
              // alert('total '+total_price);
              // alert('freegift1 '+freeGift1);
              //   alert('freegift2 '+freeGift2);
                removeFromCart(inCart.product2VarId) // Assuming inCart is defined elsewhere
                  .then(success => {
                    if (success) {
                      console.log('remvove second free gift success');
                      product2InCart = false;
                    } else {
                      console.log('remvove second free gift failed');
                    }
                  })
                  .catch(error => {
                    console.error('An unexpected error occurred during removal process:', error);
                  });
                
              }
              
          });
});



(function () {
  'use strict';
  var busy = false, lastFix = '', lastFixAt = 0, fixWindow = 0, fixRounds = 0, scanTimer = null;

  function drawerSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function swapSections(sections, drawerId) {
    Object.keys(sections || {}).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === drawerId) {
        var target = document.getElementById('cart-drawer'), fresh = doc.getElementById('cart-drawer');
        if (target && fresh) target.innerHTML = fresh.innerHTML;
      } else {
        var live = document.getElementById('shopify-section-' + id), next = doc.getElementById('shopify-section-' + id);
        if (live && next) live.innerHTML = next.innerHTML;
      }
    });
  }

  function apply(updates, ownSectionId) {
    var drawerId = drawerSectionId(), ids = [];
    if (drawerId) ids.push(drawerId);
    if (ownSectionId && ids.indexOf(ownSectionId) < 0) ids.push(ownSectionId);
    busy = true;
    var body = { updates: updates };
    if (ids.length) body.sections = ids.join(',');
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        document.querySelectorAll('cart-count').forEach(function (c) { c.innerText = data.item_count; });
        swapSections(data.sections, drawerId);
      })
      .catch(function (e) { console.warn('[ks-gift] update failed', e); })
      .then(function () { busy = false; queueScan(); });
  }

  function scan() {
    try {
      if (busy) return;
      var scripts = document.querySelectorAll('script[data-ks-gift-fix]:not([data-ks-done])');
      if (!scripts.length) return;
      var updates = {}, own = null;
      scripts.forEach(function (sc) {
        sc.setAttribute('data-ks-done', '1');
        try {
          JSON.parse(sc.textContent || '[]').forEach(function (f) {
            if (f && f.key) updates[f.key] = f.quantity;
          });
        } catch (e) { /* ignore a broken list */ }
        if (!own) {
          var sec = sc.closest('[id^="shopify-section-"]');
          if (sec && !/__cart-drawer$/.test(sec.id)) own = sec.id.replace('shopify-section-', '');
        }
      });
      var txt = JSON.stringify(updates), now = Date.now();
      if (txt === '{}') return;
      if (txt === lastFix && now - lastFixAt < 4000) return;   // the same list from two renders of one cart
      lastFix = txt; lastFixAt = now;
      if (now - fixWindow > 15000) { fixWindow = now; fixRounds = 0; }
      if (++fixRounds > 4) return;                            // a bad configuration can never loop
      console.log('[ks-gift] correcting free gifts', updates);
      apply(updates, own);
    } catch (e) { console.warn('[ks-gift] guard error', e); }
  }

  function queueScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueScan);
  } else {
    queueScan();
  }
  ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(queueScan, 150); });
  });
  if (window.MutationObserver) {
    new MutationObserver(function () { queueScan(); })
      .observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  // Block a second submit of the same gift form inside the add round-trip (13 Sep).
  var ksLastGiftSubmit = 0;
  document.addEventListener('submit', function (e) {
    var wrap = e.target && e.target.closest ? e.target.closest('.product-add') : null;
    if (!wrap) return;
    var now = Date.now();
    if (now - ksLastGiftSubmit < 3000) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
    ksLastGiftSubmit = now;
    var btn = wrap.querySelector('.add_button');
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';
      setTimeout(function () { btn.removeAttribute('aria-disabled'); btn.style.pointerEvents = ''; }, 3000);
    }
  }, true);
})();

/* =========================================================================================
   CRO round, 22 Sep 2026: a plus/minus stepper on every cart line.
   The cart drawer had only a bare text input and a "Verwijderen" link, so the one-tap way to
   say "one more pair" did not exist and changing your mind meant deleting the line. Handled by
   delegation because the drawer re-renders itself server-side after every quantity change.
   ========================================================================================= */
(function () {
  'use strict';
  var timers = new WeakMap();

  function sync(root) {
    (root || document).querySelectorAll('.ks-stepper').forEach(function (s) {
      var input = s.querySelector('input[data-line-key]');
      var minus = s.querySelector('[data-ks-qty="-1"]');
      var plus = s.querySelector('[data-ks-qty="1"]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10);
      if (minus) minus.disabled = v <= 1;              // never a dead tap; removing is the link's job
      if (plus) plus.disabled = !isNaN(max) && v >= max;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ks-qty]');
    if (!btn || btn.disabled) return;
    var wrap = btn.closest('.ks-stepper');
    var input = wrap && wrap.querySelector('input[data-line-key]');
    if (!input) return;
    e.preventDefault();

    var max = parseInt(input.getAttribute('max'), 10);
    var next = (parseInt(input.value, 10) || 1) + (parseInt(btn.dataset.ksQty, 10) || 0);
    if (next < 1) next = 1;
    if (!isNaN(max) && next > max) next = max;
    if (String(next) === String(input.value)) return;

    input.value = String(next);                         // optimistic, so the number moves under the thumb
    sync(wrap);
    clearTimeout(timers.get(input));
    timers.set(input, setTimeout(function () {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 350));                                           // one cart request for a burst of taps
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
  ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(sync, 60); });
  });
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () { sync(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
